/**
 * @generated SignedSource<<10c4e9f9af5ac05d6b092b57a1652e80>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderWithAIFilters$data = {
  readonly userPreferences: {
    readonly " $fragmentSpreads": FragmentRefs<"main_jqlBuilder_JQLBuilder">;
  } | null | undefined;
  readonly " $fragmentType": "JQLBuilderWithAIFilters";
};
export type JQLBuilderWithAIFilters$key = {
  readonly " $data"?: JQLBuilderWithAIFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderWithAIFilters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "JQLBuilderWithAIFilters",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "main_jqlBuilder_JQLBuilder"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "5bd61672089dbcc84e37cf5e8dc69396";

export default node;
